import { CsRecipe } from '../../../common/models/content-studio.model';
import { CAMERA_ANGLES, CAMERA_MOVES, STUDIO_FORMATS, STUDIO_LOOKS } from './studio-contract';

const opt = (values: readonly string[]) => values.map((v) => ({ value: v, label: v.replace(/-/g, ' ') }));

/**
 * The Studio's two recipes, described for the canvas so a shot built on the
 * board can be shown and re-run there. Retired so the canvas's own picker
 * does not offer them: on the canvas they only arrive with a board.
 */
export const STUDIO_CANVAS_RECIPES: CsRecipe[] = [
    {
        slug: 'studio-still',
        name: 'Studio shot',
        description: 'A shot from the Studio board: product, scene, camera and look.',
        outputKind: 'image',
        capability: 'image-to-image',
        creditCost: 18,
        requiresProduct: true,
        requiresSourceAsset: false,
        retired: true,
        inputs: [
            { key: 'scene', label: 'Where', type: 'textarea', required: true },
            { key: 'camera', label: 'Camera', type: 'select', options: opt(CAMERA_ANGLES), default: 'three-quarter' },
            { key: 'cameraNote', label: 'Framing', type: 'text' },
            { key: 'action', label: 'What happens', type: 'textarea' },
            { key: 'look', label: 'Look', type: 'select', options: opt(STUDIO_LOOKS), default: 'editorial' },
            { key: 'format', label: 'Format', type: 'select', options: opt(STUDIO_FORMATS), default: '4:5' },
        ],
    } as any,
    {
        slug: 'studio-clip',
        name: 'Studio film',
        description: 'A shot from the Studio board, filmed from its photo.',
        outputKind: 'video',
        capability: 'image-to-video',
        creditCost: 200,
        requiresProduct: false,
        requiresSourceAsset: true,
        retired: true,
        inputs: [
            { key: 'action', label: 'What happens', type: 'textarea' },
            { key: 'motion', label: 'Camera move', type: 'select', options: opt(CAMERA_MOVES), default: 'push-in' },
            { key: 'durationSec', label: 'Seconds', type: 'number', min: 4, max: 10, step: 1, default: 5 },
            { key: 'engine', label: 'Quality', type: 'select', options: [{ value: 'fast', label: 'Fast' }, { value: 'cinematic', label: 'Cinematic' }] },
        ],
    } as any,
];
